/*================ CGI Factory
========================================*/
angular
  .module('vppApp')
  .factory('CGIFactory', ['$http', function ($http) {
  return {
    getCGI: function(priceInfo, key, year, make) {
      if(!priceInfo[key]){
        return;
      }

      var mmc = priceInfo[key].lowStyle.mmc;
      var pegCode = priceInfo[key].lowStyle.pegCode;
      var colorCode = priceInfo[key].lowStyle.extColorCode;
      if(pegCode!=null){
        pegCode ="__" + pegCode;
      }else{
        pegCode = "";
      }
      if(make === 8){
        make = 'chevrolet';
      } else if(make === 6){
        make = 'buick';
      } else if(make === 15){
        make = 'gmc';
      } else if(make === 7){
        make = 'cadillac';
      }
      // go back to below when CGI server issue is fixed
      // if (environment === 'PROD') {
      //   return "https://cgi."+make+".com/mmgprod-us/dynres/prove/image.gen?i="+year+"/"+mmc+"/"+mmc+pegCode+"/"+colorCode+"_gmds1.png&v=deg01&std=true&country=US";
      // } else {
      //   return "https://cgi.pprod."+make+".com/mmgpprod-us/dynres/prove/image.gen?i="+year+"/"+mmc+"/"+mmc+pegCode+"/"+colorCode+"_gmds1.png&v=deg01&std=true&country=US";
      // }
      // remove when CGI preprod server issue is fixed
      return "https://cgi."+make+".com/mmgprod-us/dynres/prove/image.gen?i="+year+"/"+mmc+"/"+mmc+pegCode+"/"+colorCode+"_gmds1.png&v=deg01&std=true&country=US";
    }
  };
}]);
